import { PublicClientApplication, LogLevel } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: '3b3c7b93-6f38-436f-9d95-d8f4e9899e6f',
    authority: 'https://login.microsoftonline.com/ca9030b5-20c6-4842-a755-c6128d0e5861',
    redirectUri: 'https://sales.duvelusa.com/',
    //redirectUri: 'http://localhost:3002',
    navigateToLoginRequestUrl: true,  //uncomment out for production environment!!!!!!
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      logLevel: LogLevel.Error,
      piiLoggingEnabled: false
    }
  }
};

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;